import {observer} from 'mobx-react-lite';
import React, {useContext} from 'react';
import {StoreContext} from './root-store';
import {Notification} from '../../../patterns';

export const GenericError = observer((): JSX.Element => {
    const {labelStore} = useContext(StoreContext);

    return <Notification
        title={labelStore.label('common.error.title')}
        text={labelStore.label('common.error.details')}
        defaultIsOpen={true}
        type="error"
    />;
});
